module.exports = __webpack_public_path__ + "kudos_11.svg?887891918046778c563ae83acad62de7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_11.svg
// module id = 108
// module chunks = 0